var exports = {
  "kL": "AvatarStack.module__container___YjlOMT",
  "my": "AvatarStack.module__avatar___YjlOMT",
  "KI": "AvatarStack.module__avatarButton___YjlOMT",
  "vn": "AvatarStack.module__avatarContent___YjlOMT",
  "ML": "AvatarStack.module__avatarContextMenuWrap___YjlOMT",
  "hm": "AvatarStack.module__withMask___YjlOMT",
  "i1": "AvatarStack.module__remainingCount___YjlOMT",
};

module.exports = exports;
